/**
 * Cart-drawer upsell add-to-cart binder (see snippets/la-cart-upsell.liquid).
 *
 * Why this is a separate asset rather than an inline <script> in the snippet:
 * the upsell only renders when the cart has items, so on a first page load with an
 * empty cart its markup — and any inline script inside it — does not exist. The
 * drawer then morphs the upsell in after the first add, and script elements
 * inserted by a morph/innerHTML never execute. The binder has to be loaded by
 * snippets/cart-drawer.liquid itself, which renders on every page regardless of
 * cart state.
 *
 * The listener is delegated on `document` so it keeps working across every
 * subsequent drawer re-render without rebinding.
 *
 * The hook is `data-lacu-atc`, deliberately NOT the `data-la-atc` used by
 * product-card--la: sections/main-collection
 * .liquid binds its own document-level listener on `[data-la-atc]`, and the drawer
 * is present on collection pages too — sharing the hook would double-add.
 */
(function () {
  if (window.__laCartUpsellBound) return;
  window.__laCartUpsellBound = true;

  function add(items) {
    // assets/la-cart-add.js refreshes the drawer + free-shipping bar through
    // Horizon's own cart machinery. If it somehow has not evaluated yet, fall back
    // to a plain add + reload rather than silently dropping the click.
    if (window.LAAddToCart) return window.LAAddToCart(items);
    return fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/javascript' },
      body: JSON.stringify({ items: items }),
      credentials: 'same-origin',
    }).then(function (r) {
      if (!r.ok) throw new Error('add failed');
      window.location.reload();
    });
  }

  /* --- collapse state -----------------------------------------------------
   * The drawer re-renders after every add, and each render arrives with the
   * merchant's default open/closed state from Liquid. Without this the panel would
   * spring back open the moment a shopper added something, undoing their choice.
   * `toggle` does not bubble, so the listener is registered in the capture phase.
   */
  var OPEN_KEY = 'la:cart-upsell:open';

  document.addEventListener(
    'toggle',
    function (e) {
      var d = e.target;
      if (!d || !d.matches || !d.matches('[data-lacu-panel]')) return;
      try {
        localStorage.setItem(OPEN_KEY, d.open ? '1' : '0');
      } catch (err) {
        /* private mode: the panel still works, it just won't be remembered */
      }
    },
    true
  );

  /* --- open upward --------------------------------------------------------
   * The panel rests on the checkout summary, so opening it should reveal the
   * tiles above Discount. When the drawer body has no spare height, the tiles
   * would instead grow down under the sticky summary; scrolling the body to its
   * end puts them back where the shopper is looking. Only for a shopper's own
   * click: restore() also opens panels, and must never move the drawer.
   */
  var userToggle = false;

  document.addEventListener('click', function (e) {
    if (e.target.closest && e.target.closest('[data-lacu-panel] > summary')) userToggle = true;
  });

  document.addEventListener(
    'toggle',
    function (e) {
      var d = e.target;
      if (!d || !d.matches || !d.matches('[data-lacu-panel]')) return;
      var mine = userToggle;
      userToggle = false;
      if (!mine || !d.open) return;
      var body = d.closest('.cart-drawer__content');
      if (!body || body.scrollHeight <= body.clientHeight) return;
      var reduce = window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches;
      body.scrollTo({ top: body.scrollHeight, behavior: reduce ? 'auto' : 'smooth' });
    },
    true
  );

  function restore() {
    var stored;
    try {
      stored = localStorage.getItem(OPEN_KEY);
    } catch (err) {
      return;
    }
    if (stored === null) return; // no choice made yet: keep the merchant default
    var want = stored === '1';
    var panels = document.querySelectorAll('[data-lacu-panel]');
    for (var i = 0; i < panels.length; i++) {
      // Assigning `open` fires `toggle`; skip no-op writes.
      if (panels[i].open !== want) panels[i].open = want;
    }
  }

  // One coalesced pass per frame: a drawer morph is a burst of mutations.
  var queued = false;
  new MutationObserver(function () {
    if (queued) return;
    queued = true;
    requestAnimationFrame(function () {
      queued = false;
      restore();
    });
  }).observe(document.documentElement, { childList: true, subtree: true });

  restore();

  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-lacu-atc]');
    if (!btn || btn.disabled) return;

    var vid = btn.getAttribute('data-variant-id');
    if (!vid) return;

    btn.disabled = true;
    btn.setAttribute('aria-busy', 'true');
    // No success state to restore: a successful add re-renders the drawer and this
    // tile drops off the row, because it is now "already in the cart".
    add([{ id: Number(vid), quantity: 1 }]).catch(function (err) {
      console.warn('[la] cart upsell add failed', err);
      btn.removeAttribute('aria-busy');
      btn.disabled = false;
    });
  });
})();
